<template>
  <svg
    role="img"
    aria-label="Google"
    viewBox="0 0 830 270.68"
    xmlns="http://www.w3.org/2000/svg"
  >
    <use href="#google-logo" />
  </svg>
</template>

<script>
export default {
  name: 'GoogleLogo',
};
</script>
